import React from "react";
import SvgIcon from "../../../../../parts/SvgIcon";
import {
  MILESTONE_ICONS,
  milestonePillLabel,
  readablePhaseColorOnDark,
  readablePhaseColorOnLight,
} from "../../../../../utils/annual-planner-helpers";

// Shared by List view's phase/milestone columns and the Weekly Notes
// panel's context chips - lives here (not in either) so neither ends up
// depending on the other for a UI atom both use.
//
// --phase-pill-color-readable(-light) feed the per-theme text color (see
// .phase-pill/.summary-pill.colored, annual-planner.css) - CSS picks
// whichever one applies for the active theme, so `color` is never set
// directly here anymore (an inline style would always beat that CSS).
export const PhasePill = ({ name, color }) => (
  <span
    className="phase-pill"
    style={{
      "--phase-pill-color": color,
      "--phase-pill-color-readable": readablePhaseColorOnDark(color),
      "--phase-pill-color-readable-light": readablePhaseColorOnLight(color),
    }}
  >
    <span className="summary-dot" style={{ backgroundColor: color }} />
    {name}
  </span>
);

export const MilestonePill = ({ milestone, units, t }) => (
  <span
    className={`summary-pill${milestone.color ? " colored" : ""}`}
    style={
      milestone.color
        ? {
            "--phase-pill-color": milestone.color,
            "--phase-pill-color-readable": readablePhaseColorOnDark(
              milestone.color
            ),
            "--phase-pill-color-readable-light": readablePhaseColorOnLight(
              milestone.color
            ),
          }
        : undefined
    }
  >
    <SvgIcon src={MILESTONE_ICONS[milestone.kind]} useCurrentColor />
    {milestonePillLabel(milestone, units, t)}
  </span>
);
